import React from 'react'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import withStateHandlers from 'recompose/withStateHandlers'
import PreviewTitleDescription from './PreviewTitleDescription'
import { Icon } from 'aria-viewer/common/components/Icon'

const state = withStateHandlers(
    {
        isVisible: false,
    },
    {
        setIsVisible: () => isVisible => ({ isVisible }),
    }
)

const style = {
    imageVideoPreviewContainer: {
        width: 376,
        height: 376,
        position: 'absolute',
        top: 0,
    },
    imageVideoPreview: {
        pointerEvents: 'none',
        position: 'relative',
        borderRadius: 4,
    },
    img: {
        maxWidth: 376,
        maxHeight: 376,
        display: 'flex',
        justifyContent: 'center',
        opacity: ({ isVisible }) => (isVisible ? 1 : 0),
        transition: '0.38s ease-out',
        objectFit: 'cover',
        objectPosition: '50% 50%',
        borderRadius: 4,
    },
    icon: {
        color: '#fff',
        position: 'absolute',
        transform: 'translateY(-50%) translateX(-50%) scale(3)',
        top: '50%',
        left: '50%',
        transition: '0.18s ease-out',
        opacity: ({ isVisible }) => (isVisible ? 0 : 1),
        pointerEvents: 'none',
    },
    iconBlur: {
        color: '#fff',
        filter: 'blur(3px)',
        position: 'absolute',
        transform: 'translateY(-50%) translateX(-50%) scale(1.5)',
        top: '50%',
        left: '50%',
        transition: '0.18s ease-out',
        opacity: ({ isVisible }) => (isVisible ? 0 : 0.8),
        pointerEvents: 'none',
    },
    content: {
        pointerEvents: 'all',
        opacity: ({ isVisible }) => (isVisible ? 1 : 0),
        transition: '0.38s ease-out',
    },
}

const ImageVideoPreview = ({
    classes,
    title,
    description,
    mediaUrl,
    setIsVisible,
    offsetX,
    offsetY,
    imgDimensions,
    dimensionsCallback,
}) => {
    const hanldeOnLoad = event => {
        setIsVisible(true)
        dimensionsCallback({ width: event.target.clientWidth, height: event.target.clientHeight })
    }

    return (
        <div className={classes.imageVideoPreviewContainer}>
            <div className={classes.imageVideoPreview}>
                <img className={classes.img} onLoad={hanldeOnLoad} src={mediaUrl} />
                <div className={classes.content}>
                    <PreviewTitleDescription
                        title={title}
                        description={description}
                        leftOffset={-40}
                        isVisible={true}
                        offsetX={offsetX}
                        offsetY={offsetY}
                    />
                </div>
                <Icon className={classes.iconBlur}>query_builder</Icon>
                <Icon className={classes.icon}>query_builder</Icon>
            </div>
        </div>
    )
}

export default compose(state, injectJss(style))(ImageVideoPreview)
